export default {
  // Signatures
  mySignatures: {
    english: "My Signatures",
    spanish: "Mis firmas",
  },
  noDocuments: {
    english: "You have no documents",
    spanish: "No tienes documentos",
  },
  unsigned: {
    english: "Unsigned",
    spanish: "no firmado",
  },
  signNow: {
    english: "Sign Now",
    spanish: "Firmar ahora",
  },
  signed: {
    english: "Signed",
    spanish: "Firmado",
  },
  view: {
    english: "View",
    spanish: "Vista",
  },
  signatureUnavailable: {
    english: "Unable to open document",
    spanish: "No se puede abrir el documento",
  },
  signatureUnavailableMessage: {
    english: "We couldn't open your document for signing. Please try again.",
    spanish:
      "No pudimos abrir su documento para firmarlo. Por favor, inténtelo de nuevo.",
  },
  popupBlocked: {
    english: "Pop-up blocked",
    spanish: "Ventana emergente bloqueada",
  },
  popupBlockedMessage: {
    english:
      "Allow pop-ups for this site, then select Sign Now again.",
    spanish:
      "Permita ventanas emergentes para este sitio y luego seleccione Firmar ahora de nuevo.",
  },
};
